import {getFreeFormAngleOutline} from './freeFormAngleOutline';
import {isSimpleFreeFormOutline, matchFreeFormOutline} from './freeFormAngleHelper';

// Rebuild freeForm metadata from paired outline corners after ordinary dimension edits.
// Validate against the actual polygon so unsupported contour edits are never overwritten.
export function recoverFreeFormCenterline(shapePoints, referencePoints) {
  const count = referencePoints.length;
  if (shapePoints.length !== count * 2 || !isSimpleFreeFormOutline(shapePoints)) {
    return null;
  }
  let best = null;
  for (const direction of [1, -1]) {
    for (let start = 0; start < shapePoints.length; start++) {
      const ordered = shapePoints.map((point, index) => shapePoints[
        (start + direction * index + shapePoints.length) % shapePoints.length
      ]);
      const points = ordered.slice(0, count).map((point, index) => {
        const opposite = ordered[ordered.length - 1 - index];
        return {x: (point.x + opposite.x) / 2, y: (point.y + opposite.y) / 2};
      });
      const widths = points.slice(1).map((point, index) => {
        const from = ordered[index];
        const to = ordered[index + 1];
        const opposite = ordered[ordered.length - 1 - index];
        const length = Math.hypot(to.x - from.x, to.y - from.y);
        return Math.abs((to.x - from.x) * (opposite.y - from.y)
          - (to.y - from.y) * (opposite.x - from.x)) / length;
      });
      if (widths.some(width => !Number.isFinite(width) || width < 0.01)
        || points.slice(1).some((point, index) => Math.hypot(point.x - points[index].x, point.y - points[index].y) < 0.01)) {
        continue;
      }
      const outline = getFreeFormAngleOutline(points, widths);
      const mapping = matchFreeFormOutline(outline, shapePoints);
      if (!mapping) {
        continue;
      }
      const score = points.reduce((sum, point, index) => sum
        + Math.pow(point.x - referencePoints[index].x, 2) + Math.pow(point.y - referencePoints[index].y, 2), 0);
      if (!best || score < best.score) {
        best = {points, widths, mapping, score};
      }
    }
  }
  return best;
}
